import React from 'react';
import { Box, Fade, Grid, Snackbar } from '@material-ui/core';
import TextWithCopy from './TextFieldWithCopy';
import DescriptionBox from './DescriptionBox';
import Title from './Title';

import { useDispatch, useSelector } from 'react-redux';
import {
    setAddress,
    setDID,
    setPrivateKey,
    _address,
    _did,
    _privateKey
} from '../redux/normalDIDSlice';
import Wallet from 'did-hd-wallet';
import { WizardButton } from './ui/WizardButton';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { trackEvent } from '../utils/google-analytics';

export default function NormalDID() {
    const address = useSelector(_address);
    const did = useSelector(_did);
    const privateKey = useSelector(_privateKey);
    const dispatch = useDispatch();

    const [snackBarState, setState] = React.useState<{ open: boolean; text: string }>({
        open: false,
        text: ''
    });

    async function generateDID() {
        try {
            const wallet = new Wallet();
            const mnemonic = wallet.generateMnemonic(128);
            wallet.fromMnemonic(mnemonic);
            const { did, privateKey, address } = await wallet.getMasterKeys();

            dispatch(setAddress(address));
            dispatch(setPrivateKey(privateKey as string));
            dispatch(setDID(did));
            trackEvent('DID Tools', 'did_created', 'did');
        } catch (error) {
            console.log('error', error);
        }
    }

    function handleClose() {
        setState({
            ...snackBarState,
            open: false
        });
    }

    function callback(success: boolean) {
        if (success) {
            setState({
                open: true,
                text: 'Copied to clipboard'
            });
        } else {
            setState({
                open: true,
                text: 'Could not copied'
            });
        }
    }

    return (
        <div>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Box
                        display="flex"
                        justifyContent="flex-start"
                        alignItems="center"
                        style={{ gap: 16 }}>
                        <Box
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: 10,
                                width: 38,
                                height: 38,
                                backgroundColor: '#2ec4b6',
                                color: '#fff'
                            }}>
                            <AddCircleOutlineIcon style={{ color: '#ffffff' }} />
                        </Box>

                        <Title>Generate DID</Title>
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <Box
                        style={{
                            border: '1px solid #2ec4b6',
                            borderRadius: 12,
                            padding: 16,
                            backgroundColor: '#fff'
                        }}>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <DescriptionBox
                                    description="You could create an Key address along with a private 
                        key and register that as a Decentralized Identity here. 
                        Click 'Generate DID' to generate a DID."
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <WizardButton
                                    data-testid="generateDID"
                                    onClick={generateDID}
                                    variant="contained"
                                    style={{ textTransform: 'uppercase' }}
                                    endIcon={<AddCircleOutlineIcon />}>
                                    Generate DID
                                </WizardButton>
                            </Grid>

                            <Grid item xs={12}>
                                <TextWithCopy label="Address" value={address} callback={callback} />
                            </Grid>

                            <Grid item xs={12}>
                                <TextWithCopy
                                    label="Private key"
                                    value={privateKey}
                                    callback={callback}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <TextWithCopy
                                    label="Decentralized ID (DID)"
                                    value={did}
                                    callback={callback}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
            </Grid>

            <Snackbar
                open={snackBarState.open}
                onClose={handleClose}
                TransitionComponent={Fade}
                message={snackBarState.text}
                autoHideDuration={5000}
            />
        </div>
    );
}
